import { GetServerSideProps } from 'next'
import React from 'react'

import { CMSPage } from '@Components/CMS/Page'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo/Server'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePost } from '@Queries/cms/SinglePost.query'

interface WishListProps extends PageProps {
  item: Page
}

export const getServerSideProps: GetServerSideProps<WishListProps> = async (context) => {
  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(
    apolloClient,
    PageType.WishList,
    '/account/wishlist',
    undefined,
    boostFromContext(context),
    context?.req?.thSplitTests,
  )
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }

  return {
    props: {
      ...await pageProps(
        context,
        { type: 'wish_list', id: '' },
        page,
        ['cart', 'cms', 'common', 'footer', 'giftcard', 'header', 'products', 'shipping', 'sidebar', 'validation'],
        true,
      ),
      item: page as Page,
    },
  }
}

const WishList = PageHOC<WishListProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <CMSPage>
      {components}
    </CMSPage>
  )
})

export default WishList
